export const popupTypes = {
  SWITCH_APPLY_TEAM: 'popup/SWITCH_APPLY_TEAM',
  SWITCH_INVITE_PLAYER: 'popup/SWITCH_INVITE_PLAYER',
  SWITCH_NOTIFICATION: 'popup/SWITCH_NOTIFICATION',
  SWITCH_EMAIL_INVITE: 'popup/SWITCH_EMAIL_INVITE',
  SWITCH_LEAVE_HACKATHON: 'popup/SWITH_LEAVE_HACKATHON',
  SWITCH_SEND_NOTIF: 'popup/SWITCH_SEND_NOTIFICATION',
  SWITCH_DELETE_TEAM: 'popup/SWITCH_DELETE_TEAM',
  SWITCH_TEAMS_INFO: 'popup/SWITCH_TEAMS_INFO',
  SWITCH_EDIT_ANSWER: 'popup/SWITCH_EDIT_ANSWER',
  SWITCH_ANSWER_TO_QUESTION: 'popup/SWITCH_ANSWER_TO_QUESTION',
  SWITCH_ADMIN_ANSWER_EDIT: 'popup/SWITCH_ADMIN_ANSWER_EDIT',
  SWITCH_ADD_POLL: 'popup/SWITCH_ADD_POLL',
  SWITCH_SHOW_VOTES: 'popup/SWITCH_SHOW_VOTES',
  SWITCH_UNIQUE_VOTES: 'popup/SWITCH_UNIQUE_VOTES'
}

export const switchAnswerToQuestionPopup = (payload) => ({
  type: popupTypes.SWITCH_ANSWER_TO_QUESTION,
  payload
})

export const switchAdminAnswerEditPopup = (payload) => ({
  type: popupTypes.SWITCH_ADMIN_ANSWER_EDIT,
  payload
})

export const switchApplyTeamPopup = (payload) => (
  {
    type: popupTypes.SWITCH_APPLY_TEAM,
    payload
  }
)

export const switchEditAnswerPopup = (payload) => (
  {
    type: popupTypes.SWITCH_EDIT_ANSWER,
    payload
  }
)

export const switchInvitePlayer = (payload) => (
  {
    type: popupTypes.SWITCH_INVITE_PLAYER,
    payload
  }
)

export const switchEmailInvite = (payload) => (
  {
    type: popupTypes.SWITCH_EMAIL_INVITE,
    payload
  }
)

export const switchNotification = (payload) => (
  {
    type: popupTypes.SWITCH_NOTIFICATION,
    payload
  }
)

export const switchLeave = (payload) => (
  {
    type: popupTypes.SWITCH_LEAVE_HACKATHON,
    payload
  }
)

export const switchSendNotif = (payload) => (
  {
    type: popupTypes.SWITCH_SEND_NOTIF,
    payload
  }
)

export const switchDeleteTeam = () => (
  {
    type: popupTypes.SWITCH_DELETE_TEAM
  }
)

export const switchTeamsInfo = (payload) => (
  {
    type: popupTypes.SWITCH_TEAMS_INFO,
    payload
  }
)

export const switchAddPoll = (payload) => (
  {
    type: popupTypes.SWITCH_ADD_POLL,
    payload
  }
)

export const switchShowVotes = (payload) => (
  {
    type: popupTypes.SWITCH_SHOW_VOTES,
    payload
  }
)

export const switchUniqueVotes = (payload) => (
  {
    type: popupTypes.SWITCH_UNIQUE_VOTES,
    payload
  }
)



// WEBPACK FOOTER //
// ./src/actions/popup.js